
export class DateFormatter
{
    public isoDate(date: Date|null): string
    {
        if (date === null) {
            return "";
        }

        let dateString = "";
        dateString += date.getFullYear();
        dateString += "-";
        dateString += (date.getMonth() + 1).toFixed(0).padStart(2, '0');
        dateString += "-";
        dateString += date.getDate().toFixed(0).padStart(2, '0');

        return dateString;
    }

    public isoDateTime(date: Date|null): string
    {
        if (date === null) {
            return "";
        }

        let dateString = this.isoDate(date);
        dateString += " ";
        dateString += date.getHours().toFixed(0).padStart(2, '0');
        dateString += ":";
        dateString += date.getMinutes().toFixed(0).padStart(2, '0');
        dateString += ":";
        dateString += date.getSeconds().toFixed(0).padStart(2, '0');

        return dateString;
    }

    public humanDate(date: Date|null): string
    {
        if (date === null) {
            return "";
        }

        let dateString = "";
        dateString += date.getDate().toFixed(0).padStart(2, '0');
        dateString += ".";
        dateString += (date.getMonth() + 1).toFixed(0).padStart(2, '0');
        dateString += ".";
        dateString += date.getFullYear();

        return dateString;
    }

    public humanTime(date: Date|null): string
    {
        if (date === null) {
            return "";
        }

        let dateString = "";
        dateString += date.getHours().toFixed(0).padStart(2, '0');
        dateString += ":";
        dateString += date.getMinutes().toFixed(0).padStart(2, '0');

        return dateString;
    }

    public humanDateTime(date: Date|null): string
    {
        if (date === null) {
            return "";
        }

        return `${this.humanDate(date)} ${this.humanTime(date)}`;
    }
}
